import Vue from 'vue'
import Vuex from 'vuex'
import Axios from '@/libs/http'
import axios from 'axios'
import { baseurl } from '@/libs/config'

import user from './module/user'

Vue.use(Vuex)




const store = new Vuex.Store({
  state: {

  },
  getters: {
    token: state => {
      return state.user.userInfo? state.user.userInfo.token:'';
    },
    /**
     * @param {*} state 
     * @returns true-已认证；false-未认证
     */
    isAuth: state => {
      return state.user.userInfo? state.user.userInfo.auth : false;
    },
    /**
     * @param {*} state 
     * @returns {boolean} false用户  true员工
     */
    identity: state => {
      return state.user.userInfo? state.user.userInfo.role == 1 : false;
    }
  },
  mutations: {

  },
  actions: {
    /**
     * @param {*} store 
     * @param {object} params  {pathName: 请求地址,params: 请求参数}
     */
    async postAxiosNoToken (store, params) {
      /* 获取搜索地址，以及对应表格 ID */
      let pathName = params.pathName
      // 搜索请求所需参数
      let url = pathName;

      let data = params.params || {};
      let result = await Axios.post(url, data)

      return {
        ...result
      }
    },
    /**
     * @param {*} store 
     * @param {object} params  {pathName: 请求地址,params: 请求参数}
     */
    async postAxios(store, params,urlFlag) {
      /* 获取搜索地址，以及对应表格 ID */
      let pathName = params.pathName
      // 搜索请求所需参数
      let url = pathName;
      let token = store.getters.token
      let data = params.params || {};
      let result = await Axios.post(url, data,{
        headers: {
          token: token
        },
        responseType: params.responseType? 'blob':''
      })

      return {
        ...result
      }
    },
    async getAxios(store, params) {
      /* 获取搜索地址，以及对应表格 ID */
      let pathName = params.pathName
      // 搜索请求所需参数
      let url = pathName;
      let token = store.getters.token
      let data = params.params || {};
      if(params.isJoin){
        url = url + Object.values(data)[0]
      }
      let result = await Axios.get(url, {
        params: data,
        headers: {
          token: token
        }
      })
      return {
        ...result
      }
    },
    async deleteAxios(store, params) {
      /* 获取搜索地址，以及对应表格 ID */
      let pathName = params.pathName
      // 搜索请求所需参数
      let url = pathName;

      let token = store.getters.token

      let data = params.params || {};
      let result = await Axios.delete(url, {
        params: data,
        headers: {
          token: token
        }
      })

      return {
        ...result
      }
    },
    async downloadFile(store, params){
      let pathName = params.pathName
      let data = params.params || {};

      let url = pathName;

      let token = store.getters.token

      let result = await axios({
        method: 'POST',
        url: baseurl + url,
        data: JSON.stringify(data),
        headers: {
          "content-Type": "application/json",
          token: token
        },
        responseType: 'blob'
      })
      return {
        ...result
      }
    }
  },
  modules: {
    user
  }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js